import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    eligibility: translate({ id: 'order.form.bulk.eligibility.field.label' }),
  }))

  return api
}
